var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "go-list-item",
      attrs: {
        "data-template": "report",
        "data-size": "1x2",
        "data-source": _vm.source,
      },
    },
    [
      _c(
        "div",
        { staticClass: "go-card-main" },
        [
          _vm.formModel &&
          _vm.formModel.requestId !== undefined &&
          _vm.formModel.requestId !== "" &&
          (!_vm.formModel.docId || _vm.formModel.docId === "") &&
          _vm.formModel.isLoadingCard === true
            ? _c("loading-report-card-component", {
                key: _vm.formModel && _vm.formModel.requestId,
                attrs: { "form-model": _vm.formModel },
              })
            : [
                _c("div", { staticClass: "go-card-header" }, [
                  _c(
                    "a",
                    {
                      staticClass: "go-card-img",
                      on: { click: _vm.viewDetail },
                    },
                    [
                      _c("img", {
                        attrs: {
                          loading: "lazy",
                          src: _vm.formModel.thumbnail
                            ? _vm.formModel.thumbnail
                            : _vm.reportFailedImg,
                        },
                        on: { error: _vm.onImageError },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: [
                        "go-card-label",
                        _vm.isIndepthDaily ? "in-depth" : "",
                      ],
                    },
                    [
                      _c("em", { staticClass: "go-text" }, [
                        _vm._v(
                          _vm._s(_vm.$t(_vm.makeReportTypeText(_vm.formModel)))
                        ),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "go-card-body" },
                  [
                    _c("div", { staticClass: "go-block-body" }, [
                      _c(
                        "a",
                        {
                          staticClass: "go-card-title line-clamp-2",
                          on: { click: _vm.viewDetail },
                        },
                        [_vm._v(_vm._s(_vm.formModel.title))]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "go-card-desc" }, [
                        _vm._v(_vm._s(_vm.formModel.content)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("resource-footer", {
                      attrs: {
                        "form-model": _vm.formModel,
                        "is-hide-options": _vm.isHideOptions,
                        "is-hide-add-reference": _vm.isHideAddReference,
                        "is-hide-goover": _vm.isHideGoover,
                        "is-hide-hidden": _vm.isHideHidden,
                        "is-hide-shared": _vm.isHideShared,
                      },
                      on: {
                        "add-to-reference": _vm.addToReference,
                        hide: function ($event) {
                          $event.stopPropagation()
                          return _vm.hide.apply(null, arguments)
                        },
                        share: _vm.share,
                        "select-user-social": _vm.selectUserSocial,
                        "toggle-resource": _vm.toggleResource,
                        goover: _vm.goover,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.isContentNew
                  ? _c("div", { staticClass: "go-card-new" }, [_vm._v("New")])
                  : _vm._e(),
              ],
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }